import script from "./HomeSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSection.vue?vue&type=script&setup=true&lang=js"

import "./HomeSection.vue?vue&type=style&index=0&id=67e35a7f&scoped=true&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67e35a7f"]])

export default __exports__